import { StoreKey } from "lib/Intl";

export const OT_SHOP_TYPE_COOKIE = "ot-shop-type";

export const HOME_PAGE_SLUGS: Record<StoreKey, string[]> = {
  "OT-COM": ["women", "men", "kids"],
  "OT-UK": ["women", "men", "kids"],
  "OT-DE": ["damen", "herren", "kinder"],
  "OT-BE": ["dames", "heren", "kids"],
  "OT-NL": ["dames", "heren", "kids"],
  "OT-ES": ["mujer", "hombre", "ninos"],
  "OT-FR": ["femme", "homme", "enfant"],
  "OT-IT": ["donna", "uomo", "bambini"],
  "pl-PL": ["kobiety", "mezczyzni", "dzieci"],
  "OT-ZZ": [],
  "OT-US": [],
  "": [],
};
